import { all } from 'redux-saga/effects';
import { userSagas } from './user';
import { utilSagas } from './utils';
import { personnelSagas } from './personnelSaga/personnelSaga';
import { regionSagas } from './regionSaga/regionSaga';
import { securityCompanySagas } from './securityCompany';
import { globalListSagas } from './globalList';
import { taskTemplateSagas } from './templateSaga/templateSaga';
import { cleaningTaskSagas } from './taskSaga/cleaningSaga';
import { zoneSagas } from './zonesSaga/zonesSaga';
import { businessClientSagas } from './businessClientSagas/businessClientSaga';
import { customerSagas } from './customerSaga/customerSaga';
import { assetTypeSagas } from './assetTypeSaga/assetTypeSaga';
import { assetsSagas } from './assetSaga/assetSaga';
import { departmentSagas } from './departmentsSaga/departmentSaga';
import { patrolTemplateSagas } from './patrolTemplateSaga/patrolTemplateSaga';
import { eventsSagas } from './eventsSaga/eventsSaga';
import { eventTypeSagas } from './eventTypeSagas/eventTypeSagas';
import { emergencySagas } from './emergencySaga/emergencySaga';
import { tripSagas } from './tripSaga/tripSagas';
import { attendanceSagas } from './attendanceSaga/attendanceSaga';
import { visitorSagas } from './visitorSaga/visitorSaga';
import { sitesSagas } from './sitesSaga/sitesSaga';
import { patrolTaskSagas } from './patrolTasksSaga/patrolTasksSaga';
import { taskTypeSagas } from './taskTypeSagas/taskTypesSaga';
import { pendingCompanySagas } from './pendingCompanySaga/pendingCompanySaga';
import { messageSagas } from './messageSagas/messageSagas';
import { workOrdersSagas } from './taskSaga/workOrdersSaga';
import { securitySagas } from './taskSaga/securitySaga';
import { tripTypeSaga } from './tripTypeSaga/tripTypeSaga';
import { calendarSagas } from './calendarSaga/calendarSaga';
import { visitorTypeSagas } from './visitorSaga/visitorTypeSaga';
import { companySagas } from 'sagas/companySaga/companySaga';

export default function* rootSaga() {
  yield all([
    userSagas(),
    utilSagas(),
    securityCompanySagas(),
    globalListSagas(),
    //-----------------V2 sagas--------------------
    regionSagas(),
    personnelSagas(),
    taskTemplateSagas(),
    cleaningTaskSagas(),
    zoneSagas(),
    businessClientSagas(),
    customerSagas(),
    assetTypeSagas(),
    assetsSagas(),
    patrolTemplateSagas(),
    emergencySagas(),
    eventsSagas(),
    eventTypeSagas(),
    departmentSagas(),
    tripSagas(),
    attendanceSagas(),
    sitesSagas(),
    patrolTaskSagas(),
    taskTypeSagas(),
    companySagas(),
    pendingCompanySagas(),
    messageSagas(),
    workOrdersSagas(),
    tripTypeSaga(),
    calendarSagas(),
    securitySagas(),
    visitorSagas(),
    visitorTypeSagas(),
  ]);
}
